import React from 'react';
import { ListProps } from './List.models';
import { Wrapper } from './List.styles';

export const List: React.FC<ListProps> = (props) => <Wrapper {...props}>{props.children}</Wrapper>;

export default List;
